/**
 * GA4 select_size when a Size option variant changes (not color/other).
 * Custom-size W×L tracking lives in product-block-custom-size.liquid.
 *
 * Theme Product() often only passes { id, url } — do not rely on product.options.
 * Size is detected via [data-size-option] (or label Size/Taille/Dimension).
 */
(function () {
  if (window.__bskSelectSizeVariantTracking) return;
  window.__bskSelectSizeVariantTracking = true;

  var lastKey = '';
  var lastTs = 0;
  var lastSizeValue = null;

  function pushSelectSize(params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'select_size', params);
        return;
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: 'select_size', ecommerce: params });
    } catch (e) {}
  }

  function isSizeOptionName(name) {
    var n = String(name || '').toLowerCase();
    return (
      n.indexOf('size') !== -1 ||
      n.indexOf('taille') !== -1 ||
      n.indexOf('dimension') !== -1 ||
      n.indexOf('größe') !== -1 ||
      n.indexOf('grosse') !== -1 ||
      n.indexOf('maß') !== -1 ||
      n.indexOf('mass') !== -1
    );
  }

  function findSizeOptionBlock() {
    var marked =
      document.querySelector('[data-size-option][data-product-option]') ||
      document.querySelector('[data-size-option]');
    if (marked) return marked;

    var blocks = document.querySelectorAll('[data-product-option]');
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      var labelEl =
        block.querySelector('legend, .po-variant-header__name, label, [id*="-option"]');
      var labelText = labelEl ? labelEl.textContent || '' : '';
      // Also check name=options[Size] on inputs
      var named = block.querySelector('[name^="options["]');
      var nameAttr = named && named.getAttribute('name');
      var fromName = '';
      if (nameAttr) {
        var m = nameAttr.match(/^options\[([^\]]+)\]/);
        if (m) fromName = m[1];
      }
      if (isSizeOptionName(labelText) || isSizeOptionName(fromName)) return block;
    }
    return null;
  }

  function getSizeOptionPosition() {
    var sizeBlock = findSizeOptionBlock();
    if (!sizeBlock) return -1;
    var withPos = sizeBlock.querySelector('[data-position]');
    if (withPos) {
      var pos = parseInt(withPos.getAttribute('data-position'), 10);
      if (pos >= 1 && pos <= 3) return pos;
    }
    return -1;
  }

  function sizeOptionValuesSet() {
    var set = {};
    var sizeBlock = findSizeOptionBlock();
    if (!sizeBlock) return set;
    var inputs = sizeBlock.querySelectorAll(
      'input[data-single-option-selector], input[type="radio"], button[data-single-option-selector], [data-single-option-selector]'
    );
    for (var i = 0; i < inputs.length; i++) {
      var v = inputs[i].value || inputs[i].getAttribute('value');
      if (v) set[String(v)] = true;
    }
    return set;
  }

  function getSizeValueFromVariant(variant) {
    if (!variant) return null;

    var pos = getSizeOptionPosition();
    if (pos >= 1) {
      var fromPos = variant['option' + pos];
      if (fromPos == null && Array.isArray(variant.options)) {
        fromPos = variant.options[pos - 1];
      }
      if (fromPos != null && String(fromPos) !== '') return String(fromPos);
    }

    var sizeValues = sizeOptionValuesSet();
    for (var o = 1; o <= 3; o++) {
      var ov = variant['option' + o];
      if (ov == null && Array.isArray(variant.options)) ov = variant.options[o - 1];
      if (ov != null && sizeValues[String(ov)]) return String(ov);
    }

    return null;
  }

  function getSelectedSizeFromDom() {
    var sizeBlock = findSizeOptionBlock();
    if (!sizeBlock) return null;
    var selected =
      sizeBlock.querySelector(
        'input[data-single-option-selector]:checked, [data-single-option-selector][aria-selected="true"]'
      ) || sizeBlock.querySelector('[data-single-option-selector][data-selected-value]');
    if (!selected) return null;
    return selected.value || selected.getAttribute('value') || null;
  }

  function isCustomSizeLabel(value) {
    var v = String(value || '').toLowerCase();
    return (
      v.indexOf('custom size') !== -1 ||
      v.indexOf('taille personnal') !== -1 ||
      v.indexOf('personnalis') !== -1 ||
      v === 'custom' ||
      v === 'custom+'
    );
  }

  function currencyCode() {
    return (
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      (window.theme && theme.currency && theme.currency.active) ||
      ''
    );
  }

  function productTitle(product) {
    if (product && product.title) return product.title;
    var titleEl =
      document.querySelector('[data-product-root] h1') ||
      document.querySelector('.po-overview-title') ||
      document.querySelector('h1.product-title') ||
      document.querySelector('h1');
    if (titleEl) return (titleEl.textContent || '').trim();
    return document.title || '';
  }

  function productIdFromDom(product) {
    if (product && product.id != null) return String(product.id);
    var el =
      document.querySelector('[data-product-custom-size][data-product-id]') ||
      document.querySelector('[data-product-id]');
    return el ? el.getAttribute('data-product-id') || '' : '';
  }

  function emitSelectSize(opts) {
    var sizeNow = opts.size;
    if (!sizeNow) return;

    var productId = opts.productId || '';
    var variantId = opts.variantId || '';
    var key = productId + '|variant|' + sizeNow + '|' + variantId;
    var now = Date.now();
    if (key === lastKey && now - lastTs < 600) return;
    if (lastSizeValue != null && sizeNow === lastSizeValue && key === lastKey) return;
    lastKey = key;
    lastTs = now;
    lastSizeValue = sizeNow;

    var price = opts.price;
    var itemId =
      productId && variantId
        ? 'shopify_ZZ_' + productId + '_' + variantId
        : productId
          ? 'shopify_ZZ_' + productId + '_' + productId
          : '';

    var params = {
      item_id: itemId,
      item_name: opts.itemName || '',
      item_variant: opts.itemVariant || sizeNow,
      size: sizeNow,
      variant_id: variantId,
      sku: opts.sku || '',
      quantity: 1,
      is_custom_size: isCustomSizeLabel(sizeNow),
      currency: currencyCode(),
    };
    if (price != null && Number.isFinite(price)) {
      params.price = price;
      params.value = price;
    }

    pushSelectSize(params);
  }

  function controlIsInSizeOption(el) {
    if (!el || !el.closest) return false;
    if (el.closest('[data-size-option]')) return true;
    var block = findSizeOptionBlock();
    return !!(block && block.contains(el));
  }

  function readControlValue(el) {
    if (!el) return null;
    return el.value || el.getAttribute('value') || null;
  }

  function onSizeControlInteract(el) {
    if (!el || !el.matches) return;
    if (
      !el.matches(
        '[data-single-option-selector], input[type="radio"], select, button[role="option"]'
      )
    ) {
      return;
    }
    if (!controlIsInSizeOption(el)) return;

    var sizeNow = readControlValue(el);
    if (!sizeNow) return;
    if (lastSizeValue != null && sizeNow === lastSizeValue) return;

    var variantId = el.getAttribute('data-variant-id') || '';
    var productId = productIdFromDom(null);

    emitSelectSize({
      size: sizeNow,
      productId: productId,
      variantId: variantId,
      itemName: productTitle(null),
      itemVariant: sizeNow,
    });
  }

  // Direct user interaction — does not depend on Alpine previousVariant / product.options
  document.addEventListener(
    'change',
    function (e) {
      onSizeControlInteract(e.target);
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var control = t.closest(
        '[data-size-option] [data-single-option-selector], [data-product-option] [data-single-option-selector]'
      );
      if (!control) return;
      // Radios/selects already covered by change; buttons need click.
      if (control.matches('button, [role="option"]')) {
        onSizeControlInteract(control);
      }
    },
    true
  );

  function onVariantChange(e) {
    var detail = (e && e.detail) || {};
    var variant = detail.variant;
    var previousVariant = detail.previousVariant;
    var product = detail.product;

    if (!variant) return;
    if (getSizeOptionPosition() < 1 && Object.keys(sizeOptionValuesSet()).length === 0) return;

    var sizeNow = getSizeValueFromVariant(variant) || getSelectedSizeFromDom();
    if (!sizeNow) return;

    // Prefer previousVariant when available; otherwise skip first paint only.
    if (previousVariant) {
      var sizePrev = getSizeValueFromVariant(previousVariant);
      if (sizePrev && sizeNow === sizePrev) return;
    } else if (lastSizeValue == null) {
      // Hydration / first assignment — seed last size, don't fire.
      lastSizeValue = sizeNow;
      return;
    } else if (sizeNow === lastSizeValue) {
      return;
    }

    var priceCents = variant.price != null ? Number(variant.price) : NaN;
    var price = Number.isFinite(priceCents) ? Math.round(priceCents) / 100 : undefined;

    emitSelectSize({
      size: sizeNow,
      productId: productIdFromDom(product),
      variantId: variant.id != null ? String(variant.id) : '',
      itemName: productTitle(product),
      itemVariant: variant.title || sizeNow,
      sku: variant.sku || '',
      price: price,
    });
  }

  document.addEventListener('theme:variant:change', onVariantChange);

  // Seed so the first identical paint doesn't look like a change.
  try {
    lastSizeValue = getSelectedSizeFromDom();
  } catch (err) {}
})();
